import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface OpportunityAllocationState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpportunityAllocation: [] | null | any;
}

const initialState: OpportunityAllocationState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpportunityAllocation: null,
};

export const opportunityAllocationSlice = createSlice({
  name: 'OpportunityAllocation',
  initialState,
  reducers: {
    setAllOpportunityAllocation: (state, action) => {
      state.allOpportunityAllocation = action.payload.data;
    },
    setOpportunityAllocation: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpportunityAllocationBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: () => initialState,
  },
});

export const {
  setAllOpportunityAllocation,
  setOpportunityAllocation,
  setAllOpportunityAllocationBySearch,
  reset,
} = opportunityAllocationSlice.actions;

// Selectors
export const allOpportunityAllocationDetails = (state: RootState) =>
  state.opportunityAllocation.allOpportunityAllocation;

export const getOpportunityAllocationDetails = (state: RootState) =>
  state.opportunityAllocation.data;

export const getOpportunityAllocationTotalRecords = (state: RootState) =>
  state.opportunityAllocation.totalRecords;

export const getAllOpportunityAllocationBySearch = (state: RootState) =>
  state.opportunityAllocation.data;

export default opportunityAllocationSlice.reducer;
